import React from 'react'
import Layout from '../components/Layout'
import Form from '../components/Form'

export default function AddBook() {
  return (
    <Layout>

      <main class="py-6 2xl:px-6">
        <div class="container">
          <div class="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
            
            <Form />
          </div>
        </div>
      </main></Layout>
  )
}
